import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "",
    component: () => import("../pages/Chat.vue"),
    meta: { checkAvailabilityAnonymousMode: true },
  },
  {
    path: "search",
    component: () => import("../pages/Search.vue"),
    meta: { checkAvailabilityAnonymousMode: true },
  },
  {
    path: "questions",
    component: () => import("../pages/Questions.vue"),
    meta: { checkAvailabilityAnonymousMode: true },
  },
  {
    path: "about",
    component: () => import("../pages/About.vue"),
    meta: { checkAvailabilityAnonymousMode: true },
  },
  {
    path: "feedback",
    component: () => import("../pages/Feedback.vue"),
    meta: { checkAvailabilityAnonymousMode: true },
  },
];

export default routes;
